export default __webpack_public_path__ + "static/media/apple.b3e52285.png";